import { gql, useQuery } from '@apollo/client';

export const GET_APPLICANT_BY_ID = gql`
  query getApplicantById($applicantId: ObjectId!) {
    getApplicantById(applicantId: $applicantId) {
      _id
      firstName
      lastName
      email
      status
      phoneNumber
      vacancyId
      salaryExpectations
      availableFrom
      startingDate
      feedbacks {
        feedback
        feedbackFrom
        rating
      }
      interviews {
        interviewName
        interviewSet
        feedback
        date
        interviewerId
        communicationChannel
        rating
        eventLink
      }
      documents {
        resumeFiles {
          _id
          filename
          location
        }
        salutationFiles {
          _id
          filename
          location
        }
      }
    }
  }
`;

export const useGetApplicantById = (applicantId?: string) => {
  const { data, loading } = useQuery(GET_APPLICANT_BY_ID, {
    variables: {
      applicantId,
    },
    skip: !applicantId,
    fetchPolicy: 'network-only',
  });

  return { applicant: data?.getApplicantById || {}, loading };
};
